export default {"src":"/_next/static/media/google-play-colored.1d2c8c38.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};